import { createAsyncThunk } from '@reduxjs/toolkit';
import { workerService } from 'services';
import { GetWorkerRequest, GetWorkerResponse, GetWorkerError, ThunkAPI } from 'types';

export const getDataGantt = createAsyncThunk<
  GetWorkerResponse,
  GetWorkerRequest,
  ThunkAPI<GetWorkerError>
>('tableGantt/thunk/getDataGantt', async (params, { rejectWithValue }) => {
  try {
    const { data } = await workerService.getDataGanttSupportSite(params);
    return data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
